import * as d3 from 'd3-selection'

export default function (selection, plot, scaler, chart, dimensions) {
  selection.each(function () {
    let plot = d3.select(this.parentNode)
      , plotId = plot.datum().id
      , axis = d3.select(this).selectAll('.axis-x-ticks')
      , title = d3.select(this).selectAll('.axis-x-title')
      , tick = axis.selectAll('.tick')
      , transformTick = d => {
        let x = scaler.plotScale(plotId) +
                scaler.groupScale.bandwidth() / 2 +
                scaler.groupScale(d.id)
        return `translate(${x}, 0)`
      }
      , transformTitle = d => {
        return scaler.plotScale(plotId) +
          scaler.groupScale.range()[1] / 2
      }

    tick.attr('transform', transformTick) // Set initial location
        .transition(chart.defaultTransition)
        .attr('transform', transformTick) // Override default transform to stay in this position

    title.attr('x', transformTitle)
         .transition(chart.defaultTransition)
         .attr('x', transformTitle)

    // Once the transition has ended, we can show the original ticks
    // in their proper locations
    chart.defaultTransition.end().then(() => {
      tick.attr('transform', function () {
        return `translate(${this._x}, 0)`
      })
      title.attr('x', scaler.groupScale.range()[1] / 2)
    })
  })

}
